export default __webpack_public_path__ + "static/media/armswing_sample.bd8b4abd.png";